//-------------------------------
//フェイドイン
//-------------------------------
// IntersectionObserverのオプションを設定
const options = {
	rootMargin: '0px',
	threshold: 0,
};

jQuery(function ($) {
	const fadeIn = document.querySelectorAll(".js-in");

	// IntersectionObserverを呼び出し
	const observer = new IntersectionObserver(showElement, options);

	// fadeInクラスが付与されてる要素にたどり着いたらIntersectionObserverを実行
	fadeIn.forEach((fadeIn) => {
		observer.observe(fadeIn);
	});

	// 要素が表示されたら実行する動作
	function showElement(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 要素が表示された場合、クラスをチェックして実行しないようにする
				if (!entry.target.classList.contains("js-load") && !entry.target.classList.contains("js-load-more")) {
					// 要素にactiveクラスを付与
					entry.target.classList.add("is-active");
				}
			}
		});
	}
});

//-------------------------------
//順番にフェイドイン
//-------------------------------
jQuery(function ($) {

	const fadeIn = document.querySelectorAll(".fadeIn_list");

	const observer = new IntersectionObserver(showElement, options);

	fadeIn.forEach((fadeIn) => {
		observer.observe(fadeIn);
	});

	function showElement(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("show");
			}
		});
	}

});


//-------------------------------
//ずらしてフェイドイン
//-------------------------------
$(window).on("load", function () {
	//ロードしてからスライド
	$('.js-load').delay(300).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});
});
